
import i18nCommon from '@modules/i18n/mixins/Common';
import CommonStoreOperations from '@modules/store/common/mixins/CommonStoreOperations';
import Vue, { VueConstructor } from 'vue';

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof i18nCommon> & InstanceType<typeof CommonStoreOperations>>
).extend({
  name: 'Progress',
  mixins: [i18nCommon, CommonStoreOperations],
  props: {
    progress: Object,
    commonParams: {
      type: Object,
      default: () => ({}),
    },
    lastItemDashed: {
      type: Boolean,
      default: false,
    },
    showActiveStepNameOnly: {
      type: Boolean,
      default: false,
    },
    alignLeft: {
      type: Boolean,
      default: false,
    },
    paddingLR: {
      type: Boolean,
      default: true,
    },
    routes: {
      type: Array,
    },
    showCancellation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    myRoutes(): void {
      let progressRoutes: any = [];

      if (this.routes) {
        progressRoutes = this.routes;
      } else if (this.$router.options.routes) {
        progressRoutes = this.$router.options.routes;
      }

      return progressRoutes.filter((route: any) => {
        return route.meta ? route.meta.hiddenFromProgress !== true : false;
      });
    },
    currentRouteTitle(): string {
      return this.$route.meta && this.$route.meta.title ? this.$route.meta.title : '';
    },
  },
  methods: {
    progressClass(idx: any) {
      let active_idx = 0;
      // Go over the router links, and see if we can find out which
      // router link that is active by comparing the names.
      const routes: any = this.myRoutes;
      for (const index in routes) {
        if (routes[index].name === this.$route.name) {
          active_idx = parseInt(index);
        }
      }
      return {
        complete: idx < active_idx,
        active: idx === active_idx,
        disabled: idx > active_idx,
      };
    },
    translatedProgressTitle(route: any): string {
      return route.meta && route.meta.title ? this.capitalizeFirst(this.translate(route.meta.title)) : '';
    },
  },
});
